/* eslint-disable react-hooks/exhaustive-deps */

import { Box, Button } from "@mui/material";

import React, { useEffect, useState } from "react";



import { t } from "i18next";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

import DestinationMenu from "./DestinationMenu";
import { searchDestination, searchPortLoading, searchShippingLine } from "../../../../actions/formAction";
import DynamicSearchMenu from "./DynamicSearchMenu";
import { Search } from "@mui/icons-material";
import SearchOptionMenu from "./SearchOptionMenu";
import AdvancedSearch from "../../../Vehicles/Components/searchOptionComponents/MultiFieldSearch ";
import Progress from "../../../../components/Loader/Progress ";
import MixSearch from "./MixSearch";
import BookingStatusMenu from "./BookingStatusMenu";

const DropdownMenu = ({ onFetchData }) => {
  const location = useLocation();
  const navigate = useNavigate();

  const formReducer = useSelector((state) => state.verificationBooking);
  const { accountType, loading } = useSelector((state) => state.user);

  const [adavancedSearchPrems, setAdavancedSearchPrems] = useState(
    formReducer?.data?.advancedSearches || []
  );



  useEffect(() => {
    if (formReducer.loading === "succeeded") {
      setAdavancedSearchPrems(formReducer?.data?.advancedSearches || []);
    }
  }, [formReducer.loading]);

  const handelResetFilter = () => {
    const searchParams = new URLSearchParams(location.search);

    searchParams.delete("ShippingLine");
    searchParams.delete("PortLoading");
    searchParams.delete("Destination");
    searchParams.delete("SearchOption");
    searchParams.delete("Status");
    searchParams.delete("AdvancedSearch");
    searchParams.delete("Destination");
    searchParams.delete("MixSearch");

    navigate({ search: searchParams.toString() });
  };

  return (
    <Box sx={{
      p: { xs: 1, md: 2 },
      background: '#fff',
      borderRadius: 3,
      boxShadow: '0 2px 12px 0 rgba(11, 60, 93, 0.08)',
      mb: 2,
      display: 'flex',
      flexDirection: 'column',
      gap: 2,
      alignItems: 'flex-start',
      justifyContent: 'flex-start',
      width: '100%',
    }}>
      <Box sx={{
        display: 'flex',
        flexWrap: 'wrap',
        gap: 2,
        alignItems: 'center',
        justifyContent: 'flex-start',
        width: '100%',
      }}>
        <BookingStatusMenu Selector={useSelector((state) => state.verificationBooking)} />

        <DynamicSearchMenu label="Destination" queryParam="Destination" loadingKey="isLoadingDestinationData" dataKey="destination" fetchAction={searchDestination} />

        <DynamicSearchMenu label="Port Loading" queryParam="PortLoading" loadingKey="isLoadingPortData" dataKey="portLoading" fetchAction={searchPortLoading} />
        <DynamicSearchMenu label="Shipping Line" queryParam="ShippingLine" loadingKey="isLoadingShippingLineData" dataKey="shippingLine" fetchAction={searchShippingLine} />

        <SearchOptionMenu />
        {formReducer.loading === "pending" || formReducer.loading === "idle" ? <Progress /> :
          <AdvancedSearch
            filter={adavancedSearchPrems}
          />

        }



        <Button
          color="colorD"
          variant="outlined"
          sx={{ minWidth: 120, borderRadius: 2, fontWeight: 700, borderColor: '#D9B310', color: '#0B3C5D', '&:hover': { background: '#D9B31022', borderColor: '#D9B310', color: '#0B3C5D' } }}
          onClick={handelResetFilter}
        >
          {t("ResetFilter")}
        </Button>
        <Button
          variant="b1"
          sx={{ minWidth: 120, borderRadius: 2, fontWeight: 700 }}
          onClick={onFetchData}
        >
          {t('FetchData')}
        </Button>
      </Box>

      <MixSearch/>

      <Box sx={{ width: '100%' }}>
      </Box>
    </Box>
  );
};

export default DropdownMenu;
